<template>
  <div>
    <DocumentPageTemplate :document="protocol.document">
      <template #header>
        <FilesUploader
          v-if="false"
          v-model="newFile"
          :disabled="$loading.isLoading('protocolSingle') || disabled"
          :multiple="false"
          :name-folder="protocol.number"
          :showFiles="false"
          confirmMsg
          main-folder="Протоколи"
          @change="() => protocolUpdateDocument()" />
      </template>
      <template #info>
        <Skeleton v-if="$loading.isLoading('protocolSingle')" />
        <div v-else>
          <div v-if="acknowledgmentAccess" class="mb-3">
            <v-btn
              v-if="isAcknowledgmentAgreed"
              color="success"
              style="cursor: default; pointer-events: none; width: 100%">
              <v-icon class="mr-1">
                {{ 'mdi-check' }}
              </v-icon>
              <span>Ознайомлений</span>
            </v-btn>
            <v-btn
              v-else
              class="text-white"
              color="orange"
              style="width: 100%"
              :loading="$loading.isLoading('acknowledgmentAgree')"
              @click="acknowledgmentAgree">
              <v-icon class="mr-1">
                {{ 'mdi-eye-check-outline' }}
              </v-icon>
              <span>Ознайомитись</span>
            </v-btn>
          </div>
          <InfoFields :fields="fields" class="mb-4"></InfoFields>
          <SimpleExpansionPanel class="mb-2" label="Пов'язані протоколи">
            <related-protocols :protocol="protocol"></related-protocols>
          </SimpleExpansionPanel>
          <SimpleExpansionPanel class="mb-2" label="Коментарі">
            <Comments :disabled="disabled" />
          </SimpleExpansionPanel>
          <SimpleExpansionPanel class="mb-2" label="Примітки">
            <Notes :disabled="disabled" />
          </SimpleExpansionPanel>

          <v-btn
            class="mt-3 link"
            variant="text"
            @click="showFamiliarizationUsers">
            <v-icon class="mr-1">{{ 'mdi-eye-outline' }}</v-icon>
            <span>Учасники ознайомлення</span>
          </v-btn>
        </div>
      </template>
    </DocumentPageTemplate>
  </div>
</template>

<script>
import DocumentPageTemplate from '@/components/document-page-template/Index.vue'
import Skeleton from '@/components/Skeleton.vue'
import InfoFields from '@/components/InfoFields.vue'
import Comments from '@/components/comments/v2/Comments.vue'
import Notes from '@/components/notes/Notes.vue'
import { useProtocol } from './protocol'
import { computed } from 'vue'
import { navigateToItem } from '@/utils/helpers.js'
import { openDialog } from '@/dialog/index.ts'
import SimpleExpansionPanel from '@/components/expansion-panel/SimpleExpansionPanel.vue'
import RelatedProtocols from './related-protocols/RelatedProtocols.vue'
import { useAcknowledgment } from '@/components/acknowledgment'

export default {
  name: 'DocumentLayout',
  components: {
    DocumentPageTemplate,
    Skeleton,
    InfoFields,
    Comments,
    Notes,
    SimpleExpansionPanel,
    RelatedProtocols,
  },
  setup() {
    const { protocol, disabled, newFile, protocolUpdateDocument } =
      useProtocol()
    const {
      isAcknowledgmentAgreed,
      acknowledgmentAccess,
      acknowledgmentAgree,
    } = useAcknowledgment()

    const fields = computed(() => {
      return [
        {
          label: 'Номер',
          value: protocol.number,
        },
        {
          label: 'Дата',
          value: protocol.date,
        },
        {
          label: 'Назва',
          value: protocol.name,
        },
      ]
    })

    const showFamiliarizationUsers = () => {
      openDialog({
        name: 'FamiliarizationUsers',
        dialogData: protocol.$object,
        params: {
          hideActionButtons: true,
        },
      })
    }

    const connectionProtocols = computed(() => {
      return [protocol.actual_protocol, ...(protocol.related || [])].filter(
        Boolean
      )
    })

    return {
      protocol,
      disabled,
      fields,
      newFile,
      protocolUpdateDocument,
      showFamiliarizationUsers,
      connectionProtocols,
      navigateToItem,
      isAcknowledgmentAgreed,
      acknowledgmentAccess,
      acknowledgmentAgree,
    }
  },
}
</script>
